export default function Features() {
  const features = [
    {
      icon: 'ri-lock-line',
      title: 'Military Encryption',
      description: 'AES-256 encryption ensures your data is protected with the same security standards used by governments and military organizations worldwide.',
      gradient: 'from-blue-500 to-blue-600'
    },
    {
      icon: 'ri-eye-off-line',
      title: 'No-Log Policy',
      description: 'We never track, collect, or share your private data. Your online activity is your business, and we keep it that way with our strict no-log policy.',
      gradient: 'from-purple-500 to-purple-600'
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Lightning Speed',
      description: 'Experience blazing-fast connection speeds without compromising security. Stream, download, and browse without any lag or buffering.',
      gradient: 'from-green-500 to-green-600'
    },
    {
      icon: 'ri-global-line',
      title: 'Global Network',
      description: 'Access content from anywhere with our network of 50+ server locations worldwide. Bypass geo-restrictions and enjoy true internet freedom.',
      gradient: 'from-orange-500 to-orange-600'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Kill Switch',
      description: 'Automatic kill switch protection ensures your data never leaks if your VPN connection drops unexpectedly, keeping you safe at all times.',
      gradient: 'from-pink-500 to-pink-600'
    },
    {
      icon: 'ri-devices-line',
      title: 'Multi-Device',
      description: 'Protect all your devices with a single account. Compatible with Windows, Mac, iOS, Android, and more. Secure up to 10 devices simultaneously.',
      gradient: 'from-cyan-500 to-cyan-600'
    }
  ];

  return (
    <section id="features" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-purple-100 text-purple-600 text-xs font-semibold rounded-full mb-4 uppercase tracking-widest">
            Features
          </div>
          <h2 className="text-6xl font-bold text-gray-900 mb-4 leading-tight">
            Everything You Need<br />For Complete Protection
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Advanced security features designed for modern threats
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-10 hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 cursor-pointer"
            >
              <div className={`w-16 h-16 bg-gradient-to-br ${feature.gradient} rounded-full flex items-center justify-center mb-6`}>
                <i className={`${feature.icon} text-white text-3xl`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">{feature.title}</h3>
              <p className="text-base text-gray-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
